export default __webpack_public_path__ + "static/Concept4-19b58e0b650dea13c9f148a20c402489.png";